import { render } from "./payment-history.vue?vue&type=template&id=46bdc87f"
import script from "./payment-history.vue?vue&type=script&lang=js"
export * from "./payment-history.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__